import { createActions, createReducer } from 'reduxsauce'

import DespesasPorRubricaService from '../../servicos/DespesasPorRubricaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesasPorRubricaInicio: [],
    buscaDespesasPorRubricaSucesso: ['despesasPorRubrica'],
    buscaDespesasPorRubricaErro: ['erro'],
    setDespesasPorRubricaEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDespesasPorRubrica = data => {
    return dispatch => {
        dispatch(Creators.buscaDespesasPorRubricaInicio())
        let serv = new DespesasPorRubricaService()
        serv.consultar(data)
            .then(response => dispatch(Creators.buscaDespesasPorRubricaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesasPorRubricaErro(error)))
    }
}

const buscaDespesasPorRubricaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDespesasPorRubricaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro })

const buscaDespesasPorRubricaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.despesasPorRubrica.resultado, dataAtualizacaoDados: action.despesasPorRubrica.dataAtualizacaoDados, carregando: false }
}

const setDespesasPorRubricaEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESAS_POR_RUBRICA_INICIO]: buscaDespesasPorRubricaInicio,
    [Types.BUSCA_DESPESAS_POR_RUBRICA_ERRO]: buscaDespesasPorRubricaErro,
    [Types.BUSCA_DESPESAS_POR_RUBRICA_SUCESSO]: buscaDespesasPorRubricaSucesso,
    [Types.SET_DESPESAS_POR_RUBRICA_ESTADO_DT]: setDespesasPorRubricaEstadoDT,
})
